<template>
  <Breadcrumbs
      title="Direct Loss Sale Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Direct Loss Sale Report', path: '/direct-loss-sale-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <directLossSale />
    </div>
  </div>
</template>

<script>
import directLossSale from './directLossSaleForm.vue'
export default {
  name: 'indexList',
  components: {
    directLossSale,
  },
}
</script>
